import { render, staticRenderFns } from "./addGame.vue?vue&type=template&id=32042125&scoped=true"
import script from "./addGame.vue?vue&type=script&lang=js"
export * from "./addGame.vue?vue&type=script&lang=js"
import style0 from "./addGame.vue?vue&type=style&index=0&id=32042125&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32042125",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32042125')) {
      api.createRecord('32042125', component.options)
    } else {
      api.reload('32042125', component.options)
    }
    module.hot.accept("./addGame.vue?vue&type=template&id=32042125&scoped=true", function () {
      api.rerender('32042125', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/games/addGame.vue"
export default component.exports